import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'PageBottom' })(() => ({
    root: {
        boxSizing: 'border-box',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '32px 16px',
        borderTop: '1px solid rgba(255,255,255, 0.05)'
    },
    copyright: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px'
    },
    socials: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    }
}));
